import { useRef } from 'react';

import cn from 'classnames';

import { useIntersection } from 'hooks/useIntersection';

import { Button } from 'ui/atoms/Button/Button';
import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';

import styles from './DeliveryChannels.module.scss';

import type { DeliveryChannelsProps, DeliveryItem } from './DeliveryChannels.types';

const Item = ({ item, index }: { item: DeliveryItem; index: number }) => (
  <div className={styles.item} style={{ '--i': index } as React.CSSProperties}>
    <div className={styles.itemTop}>
      <span className={styles.itemIcon}>{item.icon}</span>
      <h3 className={styles.itemName}>{item.name}</h3>
    </div>

    <p className={styles.itemDesc}>{item.description}</p>

    {item.cta.kind === 'link' ? (
      <Button type="text" size="lg" href={item.cta.href} suffixIcon="arrow-14" className={styles.itemCta}>
        {item.cta.label}
      </Button>
    ) : (
      <div className={styles.itemButtons}>
        {item.cta.buttons.map((button) => (
          <Button key={button.label} type="transparent" size="lg" href={button.href} className={styles.itemButton}>
            {button.label}
          </Button>
        ))}
      </div>
    )}
  </div>
);

export const DeliveryChannels = ({ eyebrow, title, groups, className }: DeliveryChannelsProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const revealed = useIntersection(containerRef, { threshold: 0.1 });

  return (
    <section className={cn(styles.section, className)}>
      <div className={cn(styles.container, revealed && styles.containerOn)} ref={containerRef}>
        <div className={styles.head}>
          <TitleBlock align="left" extra={eyebrow} title={title} />
        </div>

        <div className={styles.groups}>
          {groups.map((group, groupIndex) => (
            <div key={group.category} className={styles.group} style={{ '--gi': groupIndex } as React.CSSProperties}>
              <span className={styles.category}>{group.category}</span>

              <div className={styles.items}>
                {group.items.map((item, itemIndex) => (
                  <Item key={item.name} item={item} index={itemIndex} />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
